<template>
  <div class="my-applyRecord">
    <!-- <div class="title">
			<router-link to="classroom"><i></i>教室借用申请记录</router-link>
		</div> -->
    <Header title="申请记录"></Header>
    <NOdata title="暂无申请记录~" v-if="this.recordList.length == 0"></NOdata>
    <template v-else>
      <div
        class="record_box clearfix"
        @click="fn1(item)"
        v-for="(item, index) in recordList"
        :key="index"
      >
        <div :class="schoolCode == '14075' ? 'recordfl-new' : 'record_fl'">
          <p>{{ item.jsmc }}</p>
          <span>借用周次：第{{ item.weekly }}周</span>
          <span class="span1">借用星期：{{ item.dayweek }}</span>
          <span class="span1" v-if="schoolCode != '14075'">教室容量：{{ item.classroomCapacity }}</span>
          <span class="span1" v-if="!item.kcsjmc || item.kcsjmc === ''">起止节次：{{ item.node }}</span>
          <span class="span1" v-if="item.kcsjmc && item.kcsjmc !== ''">借用时间：{{ item.kcsjmc }}</span>
          <span class="span1">校区：{{ item.campus }}</span>
          <span class="span1">教学楼：{{ item.tchBuilding }}</span>
          <!-- <span class="span1">教室：{{item.jsmc}}</span> -->
        </div>
        <div :class="schoolCode == '14075' ? 'recordfr-new' : 'record_fr'" :style="{ color: color1 }">{{ item.state }}</div>
      </div>
    </template>
  </div>
</template>
<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      recordList: [],
      color1: "",
      schoolCode: sessionStorage.getItem("schoolCode")
    };
  },
  methods: {
    async Record() {
      const res = await Api.teachMyBorrowingClassrooms();
      this.recordList = res.data;
      if (this.recordList[0] && this.recordList[0].state) {
        if (this.recordList[0].state == "审核通过") {
          this.color1 = "#12DDD6";
        } else if (this.recordList[0].state == "申请失败") {
          this.color1 = "#F86969";
        } else if (this.recordList[0].state == "待审核") {
          this.color1 = "#7469F8";
        } else if (this.recordList[0].state == "待送审") {
          this.color1 = "#757DA3";
        }
      }
    },
    fn1(e) {
      if (this.schoolCode == "10534"||this.schoolCode == "12649") {
        console.log(e);
        this.$router.push({
          path: "/historyList_10534",
          query: {
            ywinstanceid:e.ywinstanceid
          }
        });
      } else {
        this.$router.push({
          path: "/recordDetail",
          query: {
            e: encodeURIComponent(JSON.stringify(e))
          }
        });
      }
    }
  },
  created() {
    this.Record();
  }
};
</script>
<style lang="less" scoped>
.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
}
.clearfix::after {
  clear: both;
}
.clearfix {
  *zoom: 1;
}
.my-applyRecord {
  height: 86vh;
  padding: 0 20px;
  overflow: auto;
}
.record_box {
  background: @attendance-background-color-10;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 20px;
  box-sizing: border-box;
}
.record_fl {
  float: left;
  width: 72%;
}
.record_box p {
  color: @attendance-color-1;
  font-size: 16px;
  font-weight: 600;
}
.record_box span {
  display: inline-block;
  color: @attendance-color-2;
  font-size: 12px;
  margin-top: 8px;
}
.record_box .span1 {
  display: block;
  margin-top: 2px;
}
.record_fr {
  float: right;
  width: 21%;
  text-align: center;
  line-height: 80px;
  margin-right: 18px;
  font-size: 14px;
  font-weight: 700;
  /* color: #7469F8 */
}
.recordfl-new {
  width: 100%;
}
.recordfr-new {
  text-align: center;
  line-height: 1.875rem;
  font-size: 1rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/roomBorrow/borrowList.vue